import React, { Component } from "react";
import StatusCheck from "../components/StatusCheck";
import EditableDataContainer from "../containers/EditableDataContainer";
import PURCHASEIRQAddressView from "../views/IrqAddressView";
import AppRoutes from "../config/AppRoutes";
import ApiConfig from "../config/ApiConfig";
import { getUserId } from "../util/storage/accessTokenStorage";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { boolean, object, string } from "yup";

class PurchaseIrqAddressPage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="purchaseIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={object().shape({
            street: string().required("This field is required"),
            city: string().required("This field is required"),
            state: string().required("This field is required"),
            zip: string().required("This field is required"),
          })}
        >
          <PURCHASEIRQAddressView
            content={contentMap.PurchaseIrqAddressPage}
            navigationsAway={customNavigationMap.PurchaseIrqAddressPage}
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(PurchaseIrqAddressPage);
